/* PIKA PDP – lazy sekce: Další produkty značky, Hodí se k…, Naposledy prohlížené. Vše po doscrollování (IntersectionObserver). */
(function () {
  if (window.__pikaPdp) return;
  window.__pikaPdp = 1;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LS = 'pika_rv';

  function lazy(el, fn) {
    var done = false;
    function go() { if (done) return; done = true; try { fn(); } catch (e) { window.__pikaErr = String(e); hide(el); } }
    if (!('IntersectionObserver' in window)) { go(); return; }
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); }
    }, { rootMargin: '1500px 0px' });
    io.observe(el);
    /* 30. 9. — po události load (až po LCP) +0,8 s se sekce doplní i bez doscrollování, ať se patička nikdy neposune viditelně; před tím jen IO s okrajem 1500 px */
    function idleGo() { setTimeout(function () { if (!done) { io.disconnect(); go(); } }, 800); }
    if (document.readyState === 'complete') idleGo(); else window.addEventListener('load', idleGo, { once: true });
    // skrytá záložka / vypnuté vykreslování: IO se nespustí → načíst po 1,5 s, ať nezůstane věčný skeleton
    if (document.visibilityState === 'hidden' || document.hidden) setTimeout(function () { io.disconnect(); go(); }, 1500);
    document.addEventListener('visibilitychange', function h() { if (document.hidden) setTimeout(function () { if (!done && document.hidden) { io.disconnect(); go(); } }, 1500); });
  }
  function get(q, view) {
    var u = root + 'search?q=' + encodeURIComponent(q) + '&type=product&sort_by=best-selling&view=' + view;
    return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
  }
  function frag(html) { var t = document.createElement('template'); t.innerHTML = html; return t.content; }
  function hide(el) { var w = el.closest('[data-pika-wrap]') || el; w.hidden = true; }

  var PREV = '<button is="prev-button" class="circle-button circle-button--lg circle-button--fill border group" aria-controls="ID" disabled><span class="sr-only">‹</span><span class="animated-arrow animated-arrow--reverse"></span></button>';
  var NEXT = '<button is="next-button" class="circle-button circle-button--lg circle-button--fill border group" aria-controls="ID"><span class="sr-only">›</span><span class="animated-arrow"></span></button>';
  function carousel(el, cards) {
    var id = 'scroll-area-' + el.dataset.sid;
    var body = el.querySelector('[data-pika-body]');
    body.innerHTML = '<div class="floating-controls-container"><scroll-carousel selector="product-card" id="' + id +
      '" class="scroll-area is-carousel bleed bleed-right' + (cards.length > 4 ? ' is-scrollable' : '') +
      '"><product-list class="product-list">' + cards.join('') + '</product-list></scroll-carousel>' +
      PREV.replace('ID', id) + NEXT.replace('ID', id) + '</div>';
  }
  function cardsOf(html, cur, seen, out, curC, mine) {
    var f = frag(html), meta = {}, arr = [];
    f.querySelectorAll('i[data-h]').forEach(function (m) { meta[m.getAttribute('data-h')] = m; });
    f.querySelectorAll('product-card').forEach(function (c, i) {
      var h = c.getAttribute('handle');
      if (h && h !== cur && !seen[h]) {
        seen[h] = 1;
        var m = meta[h];
        arr.push({ html: c.outerHTML, i: i, r: curC ? rank(curC, mine, m && m.getAttribute('data-colors'), m && m.getAttribute('data-sizes'), 1) : 0 });
      }
    });
    if (curC) arr.sort(function (a, b) { return b.r - a.r || a.i - b.i; });
    arr.forEach(function (a) { out.push(a.html); });
  }

  function initBrand(el) {
    var v = (el.dataset.vendor || '').replace(/"/g, ''), cur = el.dataset.handle, sid = el.dataset.sid;
    var tags = (el.dataset.tags || '').split('|').filter(Boolean), curC = cols(el.dataset.colors), mine = mySizes();
    lazy(el, function () {
      window.__pikaFired = 1;
      var out = [], seen = {}, base = 'vendor:"' + v + '"';
      var p = tags.length ? get(base + ' AND (' + tags.map(function (t) { return 'tag:' + t; }).join(' OR ') + ')', 'pika-brand') : Promise.resolve('');
      p.then(function (h) { cardsOf(h, cur, seen, out, curC, mine); })
        .then(function () {
          if (out.length >= 12) return '';
          return get(tags.length ? base + ' AND ' + tags.map(function (t) { return '-tag:' + t; }).join(' AND ') : base, 'pika-brand');
        })
        .then(function (h) { if (h) cardsOf(h, cur, seen, out, curC, mine); })
        .then(function () {
          out = out.slice(0, 12);
          if (!out.length) return hide(el);
          carousel(el, out);
        }).catch(function (e) { window.__pikaErr = String(e && e.stack || e); hide(el); });
    });
  }

  var NEUT = /^(černá|bílá|šedá|béžová|krémová|čierna|biela|sivá|black|white|gr[ae]y|beige|cream|ecru)$/;
  var WARM = /(červen|oranž|žlut|růžov|bordó|hněd|zlat|red|orange|yellow|pink|brown|gold|burgundy)/;
  var COOL = /(modr|zelen|fialov|tyrkys|blue|green|purple|teal|navy)/;
  function cols(x) { return (x || '').split('|').filter(Boolean); }
  function fam(c) { return NEUT.test(c) ? 'n' : WARM.test(c) ? 'w' : COOL.test(c) ? 'c' : 'o'; }
  // 4 stejná barva, 3 podobný odstín, 2 neutrální, 1 bez údaje, 0 jiná barva
  function colorScore(curC, itC, other) {
    if (!itC.length || !curC.length) return 1;
    if (itC.some(function (c) { return curC.indexOf(c) > -1; })) return 4;
    var cf = curC.map(fam), any = itC.some(function (c) { return cf.indexOf(fam(c)) > -1 && fam(c) !== 'n' && fam(c) !== 'o'; });
    if (any) return 3;
    if (itC.every(function (c) { return NEUT.test(c); })) return 2;
    return other;
  }
  function norm(t) { return String(t).toLowerCase().replace(/\b(eu|us|uk)\b/g, '').replace(/[\s]/g, ''); }
  function mySizes() {
    var out = {};
    try {
      var raw = localStorage.getItem('pika_size_v1');
      if (!raw) return out;
      var v; try { v = JSON.parse(raw); } catch (e) { v = raw; }
      (function walk(x) {
        if (x == null) return;
        if (Array.isArray(x)) return x.forEach(walk);
        if (typeof x === 'object') return Object.keys(x).forEach(function (k) { walk(x[k]); });
        var n = norm(x); if (n) out[n] = 1;
      })(v);
    } catch (e) {}
    return out;
  }
  function sizeBonus(mine, szAttr) {
    var ks = Object.keys(mine); if (!ks.length) return 0;
    var has = (szAttr || '').split('|').some(function (t) { return t.split('/').some(function (p) { return mine[norm(p)]; }); });
    return has ? 1 : 0;
  }
  function rank(curC, mine, colors, sizes, other) { return colorScore(curC, cols(colors), other) * 10 + sizeBonus(mine, sizes); }
  var TAG_KEY = { 'Mikiny': 'category_hoodies', 'Trička': 'category_tees', 'Tepláky': 'category_sweatpants', 'Kalhoty': 'category_pants', 'Kraťasy': 'category_shorts', 'Čepice': 'category_caps', 'Ponožky': 'category_socks', 'Tašky': 'category_bags', 'Tenisky': 'category_sneakers', 'Pantofle': 'category_slides', 'Boty': 'category_shoes', 'Bundy': 'category_jackets' };
  var BODY = { 'Čepice': 1, 'Mikiny': 2, 'Bundy': 2, 'Trička': 3, 'Tepláky': 4, 'Kalhoty': 4, 'Kraťasy': 4, 'Ponožky': 5, 'Tenisky': 6, 'Pantofle': 6, 'Boty': 6, 'Tašky': 7 };
  function bodyRank(k) { return BODY[k] || 7; }
  function slotsFor(grp) {
    var warm = (function () { var m = new Date().getMonth(); return m >= 3 && m <= 7; })();
    var TOP = { id: 'top', tags: ['Mikiny', 'Trička'], pref: warm ? ['Trička'] : ['Mikiny'] };
    var BOT = { id: 'bottom', tags: ['Tepláky', 'Kalhoty', 'Kraťasy'], pref: warm ? ['Kraťasy'] : ['Tepláky', 'Kalhoty'] };
    var SHO = { id: 'shoes', tags: ['Tenisky'], pref: [] };
    var ACC = { id: 'acc', tags: ['Čepice', 'Ponožky', 'Tašky'], pref: ['Čepice', 'Ponožky'] };
    return grp === 'shoes' ? [TOP, BOT, ACC] : grp === 'top' ? [BOT, SHO, ACC] : grp === 'bottom' ? [TOP, SHO, ACC] : [TOP, BOT, SHO];
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initLook(el) {
    var I18N = window.PIKA_I18N || {};
    function T(key, vars) {
      var out = I18N['pikastore.w.pdp.' + key] || '';
      if (vars) Object.keys(vars).forEach(function (name) {
        var value = String(vars[name]);
        out = out.split('__' + name.toUpperCase() + '__').join(value);
        out = out.split('{{ ' + name + ' }}').join(value);
        out = out.split('{{' + name + '}}').join(value);
        out = out.split('{{' + name + ' }}').join(value);
        out = out.split('{{ ' + name + '}}').join(value);
      });
      return out;
    }
    var cur = el.dataset.handle, v0 = (el.dataset.vendor || '').replace(/"/g, ''), curC = cols(el.dataset.colors), mine = mySizes();
    var box = el.querySelector('[data-pika-body]');
    var main;
    try { main = JSON.parse(el.querySelector('[data-pika-main]').textContent); } catch (e) { return hide(el); }
    var curPrice = Number(el.dataset.price) || main.p || 0;
    var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var band = Math.max(curPrice * 1.5, 4000 * 100 * rate);
    var mena = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CZK';
    var SAMPLE = el.dataset.moneySample || '';
    var MF = (function () {
      var m = /^(\D*?)(\d[\d.,\s  ']*\d)(\D*)$/.exec(SAMPLE.replace(/&nbsp;/g, ' '));
      if (!m) return null;
      var num = m[2], dec = /[.,]\d\d$/.test(num) ? num.charAt(num.length - 3) : '';
      var th = ''; for (var i = 0; i < num.length; i++) { var ch = num.charAt(i); if (!/\d/.test(ch) && ch !== dec) { th = ch; break; } }
      return { pre: m[1], suf: m[3], dec: dec, th: th };
    })();
    function money(c) {
      if (!MF) return (c / 100) + ' ' + mena;
      var neg = c < 0; c = Math.abs(Math.round(c));
      var whole = String(Math.floor(c / 100)), fr = String(c % 100); if (fr.length < 2) fr = '0' + fr;
      if (MF.th) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, MF.th);
      return (neg ? '-' : '') + MF.pre + whole + (MF.dec ? MF.dec + fr : '') + MF.suf;
    }
    function catName(k) { var key = TAG_KEY[k]; return key ? T(key) : k; }
    function sz(vs) { return vs.filter(function (x) { return x.a; }); }
    function hasMine(it) { return sizeBonus(mine, sz(it.vs).map(function (x) { return x.t.toLowerCase(); }).join('|')); }
    var STOP = /^(the|of|x|mens|men|womens|women|hoodie|hoody|sweatpants|sweatpant|pants|shorts|tee|t-shirt|tshirt|socks|sock|cap|beanie|hat|crewneck|shirt|jacket|pikastore|and)$/;
    function toks(t) { return String(t).toLowerCase().replace(/[^a-z0-9ěščřžýáíéúůďťňó]+/g, ' ').split(' ').filter(function (w) { return w.length > 1 && !STOP.test(w); }); }
    var mainToks = toks(main.t);
    function series(it) { var n = 0, tk = toks(it.t); tk.forEach(function (w) { if (mainToks.indexOf(w) > -1) n++; }); return Math.min(n, 6); }
    function gender(t) { t = String(t).toLowerCase(); if (/women|wmns|\(w\)|dámsk/.test(t)) return 'w'; if (/\bgs\b|\bps\b|\btd\b|kids|junior|dětsk/.test(t)) return 'k'; return 'm'; }
    var mg = gender(main.t);
    function genderOk(it) { var g = gender(it.t); return mg === 'w' ? (g === 'w' || g === 'm') : mg === 'k' ? g === 'k' : g === 'm'; }
    function score(it, pref) {
      var s = colorScore(curC, it.c || [], 0) * 100 + series(it) * 40 + hasMine(it) * 30 + (it.v === v0 ? 20 : 0) - (it.r || 0);
      if (pref.indexOf(it.k) > -1) s += 40;
      return s;
    }
    function cands(html) {
      var s = frag(html).querySelector('script[data-pika-cands]');
      try { return s ? JSON.parse(s.textContent) : []; } catch (e) { return []; }
    }
    var st = { main: { it: main, vid: null, on: true }, slots: [] };
    var alloc = {}, saveC = 0, hintTxt = '', inCart = {};
    function loadCart() { return cartItems().then(function (c) { inCart = {}; ((c && c.items) || []).forEach(function (it) { if (!(it.properties && it.properties._pika_darek)) inCart[it.variant_id] = 1; }); return c; }); }
    function pickInitial(it) { return it.vs.length === 1 && it.vs[0].a ? it.vs[0].id : null; }
    st.main.vid = pickInitial(main);
    var cartT = 0;
    function onCart() { clearTimeout(cartT); cartT = setTimeout(function () { if (sumEl) loadCart().then(function () { draw(); estimate(); }); }, 600); }
    document.addEventListener('cart:change', onCart); document.addEventListener('cart:refresh', onCart);
    // cena a velikost hlavního produktu se drží s velikostí zvolenou na PDP (size grid → variant:change)
    document.addEventListener('variant:change', function (e) {
      var id = e && e.detail && Number(e.detail.id);
      if (id && main.vs.some(function (x) { return x.id === id && x.a; }) && st.main.vid !== id) { st.main.vid = id; if (sumEl) { draw(); estimate(); } }
    });
    var slots = slotsFor(el.dataset.grp);
    function fetchSlot(sl) {
      var t = '(' + sl.tags.map(function (x) { return 'tag:' + x; }).join(' OR ') + ')';
      var qv = 'vendor:"' + v0 + '" AND ' + t;
      var COLW = /^(black|white|grey|gray|light|dark|heather|oatmeal|cream|beige|navy|blue|red|green|brown|tan|pink|purple|orange|yellow|silver|gold|iron|sand|castle|buttercream|stone|timber|jet|bright|core|off|natural|charcoal|olive|burgundy)$/;
      var vt = toks(v0), st3 = toks(main.t).filter(function (w) { return vt.indexOf(w) < 0 && !COLW.test(w); }).slice(0, 3);
      var qs = st3.length ? qv + ' AND ' + st3.join(' AND ') : null;
      return Promise.all([get(qv, 'pika-look'), get(t, 'pika-look'), qs ? get(qs, 'pika-look') : Promise.resolve('')]).then(function (r) {
        var seen = {}, all = [];
        cands(r[2]).concat(cands(r[0])).concat(cands(r[1])).forEach(function (it) {
          if (it.h === cur || seen[it.id] || !sz(it.vs).length || !genderOk(it)) return;
          seen[it.id] = 1; all.push(it);
        });
        var inBand = all.filter(function (it) { return it.p <= band; });
        var pool = inBand.length ? inBand : [];
        pool.sort(function (a, b) { var pa = sl.pref.indexOf(a.k) > -1 ? 1 : 0, pb = sl.pref.indexOf(b.k) > -1 ? 1 : 0; return (pb - pa) || (score(b, sl.pref) - score(a, sl.pref)) || (a.id - b.id); });
        return pool;
      });
    }
    lazy(el, function () {
      Promise.all(slots.map(fetchSlot)).then(function (pools) {
        var used = {};
        pools.forEach(function (pool, i) {
          var pick = pool.filter(function (it) { return !used[it.id]; })[0];
          if (!pick) return;
          used[pick.id] = 1;
          st.slots.push({ def: slots[i], pool: pool, it: pick, vid: pickInitial(pick), on: true });
        });
        if (!st.slots.length) return hide(el);
        draw();
        estimate();
      }).catch(function (e) { window.__pikaErr = String(e && e.stack || e); hide(el); });
    });

    function selVar(x) { var vs = x.it.vs; for (var i = 0; i < vs.length; i++) if (vs[i].id === x.vid) return vs[i]; return null; }
    function active() {
      var a = [];
      if (st.main.on) a.push(st.main);
      st.slots.forEach(function (s) { if (s.on) a.push(s); });
      return a;
    }
    function card(x, isMain, idx) {
      var v = selVar(x), it = x.it;
      var price = v ? v.p : it.p;
      var off = v && alloc[v.id] > 0 && x.on && !inCart[v.id] ? alloc[v.id] : 0;
      var priceH = off ? '<s class="pika-of__old">' + money(price) + '</s> <b class="pika-of__new">' + money(price - off) + '</b>' : money(price);
      var cat = isMain ? T('current_item') : catName(it.k || x.def.tags[0]);
      var inC = v && inCart[v.id];
      var sizeTxt = inC ? T('in_cart') : v ? String(v.t).replace(/^\s*EU\s*(?=\d)/i, '') : (sz(it.vs).length ? T('select_size') : T('sold_out'));
      return '<div class="pika-of__card' + (isMain ? ' is-main' : '') + (x.on ? '' : ' is-off') + '" data-i="' + idx + '">' +
        (isMain ? '' : '<input class="pika-of__chk" type="checkbox"' + (x.on ? ' checked' : '') + ' aria-label="' + esc(it.t) + '">') +
        '<button type="button" class="pika-sety__thumb" data-act="zoom" aria-label="' + T('enlarge_photo') + '">' + (it.i ? '<img src="' + esc(it.i) + '" alt="" loading="lazy">' : '') + '</button>' +
        '<div class="pika-sety__meta"><span class="pika-of__cat' + (isMain ? ' is-cur' : '') + '">' + esc(cat) + '</span>' +
        '<a class="pika-sety__title" href="' + esc(it.u) + '">' + esc(it.t) + '</a>' +
        '<p class="pika-of__price">' + priceH + '</p>' +
        (isMain ? '' : '<div class="pika-sety__swaprow"><button type="button" class="pika-sety__swapbtn" data-act="swap"><span class="pika-sety__swapchip" aria-hidden="true"><svg class="pika-sety__swapico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h15"/><path d="M15.5 5.5 19 9l-3.5 3.5"/><path d="M20 15H5"/><path d="M8.5 11.5 5 15l3.5 3.5"/></svg></span><span class="pika-sety__swaptext">' + T('swap') + '</span></button></div>') +
        '</div>' +
        '<div class="pika-of__actions"><button type="button" class="pika-of__size' + (v ? ' is-set' : '') + '" data-act="size"' + (sz(it.vs).length && !inC ? '' : ' disabled') + '>' + esc(sizeTxt) + (sz(it.vs).length && !inC ? ' ▾' : '') + '</button></div></div>';
    }
    var sumEl = null;
    function order() {
      var all = [{ x: st.main, main: true }].concat(st.slots.map(function (s, i) { return { x: s, i: i }; }));
      all.forEach(function (o, n) { o.n = n; o.r = bodyRank(o.x.it.k || (o.x.def && o.x.def.tags[0])); });
      all.sort(function (a, b) { return a.r - b.r || a.n - b.n; });
      return all;
    }
    function pkDone() { if (box.__pkT) { clearTimeout(box.__pkT); box.__pkT = null; } box.__pkDone = true; box.classList.remove('pika-of--calc'); }
    function draw() {
      var h = '<div class="pika-of__bar" data-bar hidden></div>' + order().map(function (o) { return card(o.x, !!o.main, o.main ? -1 : o.i); }).join('');
      h += '<div class="pika-of__sum" data-sum></div>';
      box.innerHTML = h;
      sumEl = box.querySelector('[data-sum]');
      /* 29. 9. — souhrn/lišta se ukáže až po prvním výpočtu úspory (žádné přepsání „Outfit za 10.060“ → „9.641“) */
      if (!box.__pkDone) { box.classList.add('pika-of--calc'); if (!box.__pkT) box.__pkT = setTimeout(pkDone, 4000); }
      paintSum();
    }
    function plural(n, a1, a2, a5) { return n === 1 ? a1 : (n >= 2 && n <= 4) ? a2 : a5; }
    function paintSum() {
      var a = active().filter(function (x) { var v = selVar(x); return !(v && inCart[v.id]); }), tot = 0, missing = 0, others = a.filter(function (x) { return x !== st.main; }).length;
      a.forEach(function (x) { var v = selVar(x); if (v) tot += v.p; else { tot += x.it.p; missing++; } });
      var n = a.length;
      var html = '<div class="pika-of__tot">' + T('outfit_for') + ' <b>' + money(tot - saveC) + '</b>' + (saveC > 0 ? ' <s class="pika-of__was">' + money(tot) + '</s>' : '') + '</div>' + (saveC > 0 ? '<div class="pika-of__save">' + T('you_save_prefix') + money(saveC) + (Math.floor(saveC * 100 / tot) >= 5 ? ' (' + Math.floor(saveC * 100 / tot) + T('percent_suffix') : '') + '</div>' : '');
      var label;
      if (!n) label = T('everything_in_cart');
      else if (!others) label = T('tick_one_more');
      else if (missing) label = T('select_size_for.' + (missing === 1 ? 'one' : 'other'), { count: missing });
      else label = T('add_items.' + (n === 1 ? 'one' : (n >= 2 && n <= 4 ? 'few' : 'other')), { count: n });
      html += '<button type="button" class="button pika-of__buy" data-act="buy"' + (others && n ? '' : ' disabled') + '>' + label + '</button><p class="pika-of__note" data-note hidden></p>';
      sumEl.innerHTML = html;
      var bar = box.querySelector('[data-bar]');
      if (bar) {
        if (saveC > 0) { bar.hidden = false; bar.className = 'pika-of__bar is-save'; bar.textContent = T('buy_more_prefix') + (missing ? T('up_to') : '') + money(saveC); }
        else if (hintTxt) { bar.hidden = false; bar.className = 'pika-of__bar'; bar.textContent = hintTxt; }
        else bar.hidden = true;
      }
    }
    function ref(node) {
      var c = node.closest('.pika-of__card'); if (!c) return null;
      var i = Number(c.getAttribute('data-i')); return i < 0 ? st.main : st.slots[i];
    }
    // --- výběr velikosti (popover / bottom-sheet) s pilulkami z set builderu ---
    var sheet = null, bd = null;
    var lockPrev = null;
    function closeSheet() { if (sheet) { sheet.remove(); bd.remove(); sheet = bd = null; document.removeEventListener('keydown', esc2); if (lockPrev !== null) { document.documentElement.style.overflow = lockPrev; lockPrev = null; } } }
    function esc2(e) { if (e.key === 'Escape') closeSheet(); }
    function openSheet(anchor, title, body) {
      closeSheet();
      bd = document.createElement('div'); bd.className = 'pika-sheet-bd'; bd.addEventListener('click', closeSheet);
      sheet = document.createElement('div'); sheet.className = 'pika-sheet'; sheet.setAttribute('role', 'dialog');
      sheet.innerHTML = '<button type="button" class="pika-sheet__x" aria-label="' + T('close') + '">×</button><h3>' + esc(title) + '</h3>';
      sheet.querySelector('.pika-sheet__x').addEventListener('click', closeSheet);
      sheet.appendChild(body);
      document.body.appendChild(bd); document.body.appendChild(sheet);
      if (window.innerWidth >= 700) { sheet.style.maxHeight = '60vh'; sheet.style.minHeight = '0'; } else { sheet.style.minHeight = '40dvh'; sheet.style.maxHeight = '70dvh'; }
      if (window.innerWidth >= 700) {
        var r = anchor.getBoundingClientRect(), w = sheet.offsetWidth || 340, l = Math.min(Math.max(8, r.left), window.innerWidth - w - 8);
        var top = r.bottom + 6; if (top + sheet.offsetHeight > window.innerHeight - 8) top = Math.max(8, r.top - sheet.offsetHeight - 6);
        sheet.style.left = l + 'px'; sheet.style.top = top + 'px';
      }
      document.addEventListener('keydown', esc2);
      if (window.innerWidth < 700) {
        lockPrev = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden';
        // pojistka: když je fixed rodičem posunutý (transform/contain), dosadíme polohu podle viewportu
        var r0 = sheet.getBoundingClientRect(), vv = window.visualViewport, vh = vv ? vv.height : window.innerHeight;
        if (r0.bottom > vh + 2 || r0.top < 0) { sheet.style.position = 'absolute'; sheet.style.bottom = 'auto'; sheet.style.top = Math.max(0, window.pageYOffset + vh - sheet.offsetHeight) + 'px'; bd.style.position = 'absolute'; bd.style.height = document.documentElement.scrollHeight + 'px'; }
        var y0 = null;
        sheet.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
        sheet.addEventListener('touchmove', function (e) { if (y0 !== null && sheet.scrollTop <= 0 && e.touches[0].clientY - y0 > 70) { y0 = null; closeSheet(); } }, { passive: true });
      }
    }
    function sizeSheet(x, anchor) {
      var wrap = document.createElement('div');
      var myS = Object.keys(mine).length;
      var hint = null;
      x.it.vs.forEach(function (v) { if (v.a && sizeBonus(mine, v.t.toLowerCase())) hint = v.t; });
      if (hint) { var p = document.createElement('p'); p.className = 'pika-of__mine'; p.textContent = T('your_size_prefix') + hint; wrap.appendChild(p); }
      var b = document.createElement('div'); b.className = 'pika-sz pika-sety__sizes'; b.style.marginTop = '0';
      x.it.vs.forEach(function (v) {
        var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'pika-sety__size' + (sizeBonus(mine, v.t.toLowerCase()) ? ' is-mine' : '');
        var tt = String(v.t), eu = /^\s*EU\s*[0-9]/i.test(tt); if (eu) { bt.setAttribute('aria-label', tt); b.setAttribute('data-pk-eu', ''); b.style.setProperty('--pk-eu-label', '"' + T('size_eu') + '"'); tt = tt.replace(/^\s*EU\s*/i, ''); }
        bt.textContent = tt; bt.disabled = !v.a; if (v.id === x.vid) bt.setAttribute('aria-selected', 'true');
        bt.addEventListener('click', function () { x.vid = v.id; closeSheet(); draw(); estimate(); });
        b.appendChild(bt);
      });
      wrap.appendChild(b);
      openSheet(anchor, T('select_size'), wrap);
    }

    // --- lightbox: stejná komponenta a třídy jako set builder (pika-ofx__lb*) ---
    var lb = null;
    function ostra(u, px) { if (typeof u !== 'string' || !/\/cdn\/shop\/|cdn\.shopify\.com/.test(u)) return u; var bez = u.replace(/([?&])width=\d+/g, '$1').replace(/[?&]$/, ''); return bez + (bez.indexOf('?') === -1 ? '?' : '&') + 'width=' + px; }
    function otevriFotky(fotky, popis) {
      var seznam = (fotky || []).filter(Boolean); if (!seznam.length) return;
      var i = 0;
      var prevF = document.activeElement;
      if (!lb) { lb = document.createElement('div'); lb.className = 'pika-ofx__lb'; lb.hidden = true; document.body.appendChild(lb); }
      lb.innerHTML = '';
      var jeviste = document.createElement('div'); jeviste.className = 'pika-ofx__lbstage';
      var vrstvy = [document.createElement('img'), document.createElement('img')];
      vrstvy.forEach(function (v) { v.className = 'pika-ofx__lbimg'; v.alt = popis || ''; v.decoding = 'async'; jeviste.appendChild(v); });
      var vrchni = 0, beh = 0;
      function obepni(w, h) {
        if (!w || !h) return;
        var uzky = window.innerWidth <= 520, r = uzky ? 10 : 14;
        var mw = (uzky ? window.innerWidth - 20 : Math.min(920, window.innerWidth * 0.92)) - r * 2, mh = window.innerHeight * (uzky ? 0.82 : 0.86) - r * 2;
        var m = Math.min(mw / w, mh / h, 3);
        jeviste.style.width = Math.round(w * m) + r * 2 + 'px'; jeviste.style.height = Math.round(h * m) + r * 2 + 'px';
      }
      var zavri = document.createElement('button'); zavri.type = 'button'; zavri.className = 'pika-ofx__lbclose'; zavri.setAttribute('aria-label', T('close_preview')); zavri.innerHTML = '&times;';
      var pocet = document.createElement('p'); pocet.className = 'pika-ofx__lbcount';
      function sipka(smer, popisek, cesta) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'pika-ofx__lbarrow pika-ofx__lbarrow--' + smer; b.setAttribute('aria-label', popisek);
        b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + cesta + '"/></svg>';
        b.addEventListener('click', function (e) { e.stopPropagation(); posun(smer === 'prev' ? -1 : 1); });
        return b;
      }
      var vlevo = sipka('prev', T('previous_photo'), 'M15 5l-7 7 7 7'), vpravo = sipka('next', T('next_photo'), 'M9 5l7 7-7 7');
      function predn() { [1, -1].forEach(function (o) { var p = new Image(); p.src = ostra(seznam[(i + o + seznam.length) % seznam.length], 1400); }); }
      function vykresli(prelnout) {
        var u = ostra(seznam[i], 1400);
        pocet.textContent = seznam.length > 1 ? i + 1 + ' / ' + seznam.length : '';
        vlevo.hidden = vpravo.hidden = seznam.length < 2;
        if (!prelnout) {
          var p1 = vrstvy[vrchni]; p1.onload = function () { obepni(p1.naturalWidth, p1.naturalHeight); }; p1.src = u;
          if (p1.complete && p1.naturalWidth) obepni(p1.naturalWidth, p1.naturalHeight);
          p1.classList.add('je-vrchni'); vrstvy[1 - vrchni].classList.remove('je-vrchni'); predn(); return;
        }
        var muj = ++beh, ci = 1 - vrchni, cil = vrstvy[ci], dalsi = new Image();
        dalsi.onload = dalsi.onerror = function () {
          if (muj !== beh) return; cil.src = u; obepni(dalsi.naturalWidth, dalsi.naturalHeight); void cil.offsetWidth;
          cil.classList.add('je-vrchni'); vrstvy[vrchni].classList.remove('je-vrchni'); vrchni = ci; predn();
        };
        dalsi.src = u;
      }
      function posun(o) { i = (i + o + seznam.length) % seznam.length; vykresli(true); }
      function konec() { try { if (prevF && prevF.focus && document.contains(prevF)) prevF.focus({ preventScroll: true }); } catch (e) {} lb.classList.remove('je-videt'); document.removeEventListener('keydown', klavesa); window.removeEventListener('resize', naOkno); setTimeout(function () { lb.hidden = true; lb.innerHTML = ''; }, 180); }
      function naOkno() { var v = vrstvy[vrchni]; if (v && v.naturalWidth) obepni(v.naturalWidth, v.naturalHeight); }
      function klavesa(e) { if (e.key === 'Escape') konec(); else if (e.key === 'ArrowLeft') posun(-1); else if (e.key === 'ArrowRight') posun(1); }
      window.addEventListener('resize', naOkno);
      zavri.addEventListener('click', konec);
      lb.onclick = function (e) {
        if (e.target === lb) { konec(); return; }
        if (!e.target.classList || !e.target.classList.contains('pika-ofx__lbimg')) return;
        var r = e.target.getBoundingClientRect(), pw = e.target.naturalWidth, ph = e.target.naturalHeight; if (!pw || !ph) return;
        var m = Math.min(r.width / pw, r.height / ph), sw = pw * m, sh = ph * m, x = e.clientX - (r.left + (r.width - sw) / 2), y = e.clientY - (r.top + (r.height - sh) / 2);
        if (x < 0 || y < 0 || x > sw || y > sh) konec();
      };
      document.addEventListener('keydown', klavesa);
      var x0 = null;
      lb.ontouchstart = function (e) { x0 = e.touches[0].clientX; };
      lb.ontouchend = function (e) { if (x0 === null) return; var d = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(d) > 40) posun(d < 0 ? 1 : -1); };
      lb.appendChild(jeviste); lb.appendChild(vlevo); lb.appendChild(vpravo); lb.appendChild(zavri); lb.appendChild(pocet);
      vykresli(false); lb.hidden = false; void lb.offsetWidth; lb.classList.add('je-videt'); zavri.focus();
    }

    // --- výměna: modal s dlaždicemi jako v set builderu (klik vybírá, lupa zvětšuje) ---
    var modal = null, altCache = {};
    function getAlts(x) {
      var k = x.it.k;
      var base = x.pool.filter(function (it) { return it.k === k; });
      if (!k) return Promise.resolve(base);
      if (!altCache[k]) altCache[k] = Promise.all([get('tag:' + k, 'pika-look'), get('vendor:"' + v0 + '" AND tag:' + k, 'pika-look')]).then(function (r) { return cands(r[0]).concat(cands(r[1])); }).catch(function () { return []; });
      return altCache[k].then(function (more) {
        var seen = {}, all = [];
        base.concat(more).forEach(function (it) {
          if (seen[it.id] || it.h === cur || it.k !== k || !sz(it.vs).length || !genderOk(it)) return;
          if (it.p > Math.max(2 * x.it.p, band) ) return;
          seen[it.id] = 1; all.push(it);
        });
        all.sort(function (a, b) { return (b.id === x.it.id) - (a.id === x.it.id) || (score(b, []) - score(a, [])) || (a.id - b.id); });
        return all;
      });
    }
    function swapModal(x) {
      getAlts(x).then(function (alts) { swapModal2(x, alts); });
    }
    function swapModal2(x, alts) {
      if (!modal) { modal = document.createElement('div'); modal.className = 'pika-ofx__modal'; modal.hidden = true; document.body.appendChild(modal); }
      modal.innerHTML = '';
      var bx = document.createElement('div'); bx.className = 'pika-ofx__modalbox';
      var head = document.createElement('div'); head.className = 'pika-ofx__modalhead';
      head.innerHTML = '<p class="pika-ofx__modaltitle">' + T('swap_other') + '</p><button type="button" class="pika-ofx__modalclose" aria-label="' + T('close') + '">&times;</button>';
      var grid = document.createElement('div'); grid.className = 'pika-ofx__grid';
      bx.appendChild(head); bx.appendChild(grid); modal.appendChild(bx);
      function konec() { modal.classList.remove('je-videt'); document.removeEventListener('keydown', nk); setTimeout(function () { modal.hidden = true; modal.innerHTML = ''; }, 170); }
      function nk(e) { if (e.key === 'Escape' && !(lb && !lb.hidden)) konec(); }
      head.querySelector('button').addEventListener('click', konec);
      modal.onclick = function (e) { if (e.target === modal) konec(); };
      document.addEventListener('keydown', nk);
      alts.slice(0, 8).forEach(function (it) {
        if (st.slots.some(function (s) { return s !== x && s.it.id === it.id; })) return;
        var b = document.createElement('button'); b.type = 'button'; b.className = 'pika-ofx__gridbtn';
        b.innerHTML = '<img class="pika-ofx__gridimg" alt="" loading="lazy" src="' + esc(it.i || '') + '"><span class="pika-ofx__gridtitle">' + esc(it.t) + '</span><span class="pika-ofx__gridcena">' + money(it.p) + '</span>';
        var lupa = document.createElement('button'); lupa.type = 'button'; lupa.className = 'pika-ofx__lupa'; lupa.setAttribute('aria-label', T('enlarge_photo'));
        lupa.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';
        b.appendChild(lupa);
        lupa.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); otevriFotky(it.im && it.im.length ? it.im : [it.i], it.t); });
        b.addEventListener('click', function () { x.it = it; x.vid = pickInitial(it); konec(); draw(); estimate(); });
        grid.appendChild(b);
      });
      modal.hidden = false; void modal.offsetWidth; modal.classList.add('je-videt');
    }
    box.addEventListener('click', function (e) {
      var t = e.target.closest('[data-act]');
      if (!t) {
        if (e.target.closest('a, button, input, select, label')) return;
        var cd = e.target.closest('.pika-of__card'); if (!cd || cd.classList.contains('is-main')) return;
        var xs = ref(cd); if (xs) { xs.on = !xs.on; draw(); estimate(); }
        return;
      }
      var act = t.getAttribute('data-act');
      if (act === 'buy') return buy(t);
      var x = ref(t); if (!x) return;
      if (act === 'size') sizeSheet(x, t); else if (act === 'swap') swapModal(x); else if (act === 'zoom') otevriFotky(x.it.im && x.it.im.length ? x.it.im : [x.it.i], x.it.t);
    });
    box.addEventListener('change', function (e) {
      if (!e.target.classList.contains('pika-of__chk')) return;
      var x = ref(e.target); if (!x) return;
      x.on = e.target.checked; draw(); estimate();
    });

    // --- sleva: STÁVAJÍCÍ systém setů v ERP (/sety/nahled na celý hypotetický košík); nic se nepočítá v tématu ---
    var estT = 0, estSeq = 0;
    function cfg() {
      var C = window.__PIKA_CART_UPSELL;
      return { api: (C && C.api) || 'https://consignthem.com', slug: (C && C.slug) || 'pikastore', C: C };
    }
    function cartItems() {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; });
    }
    var NC = {};
    function nahled(kosik, token) {
      var c = cfg(), key = JSON.stringify(kosik);
      if (NC[key]) return NC[key];
      var p = fetch(c.api + '/api/v1/sety/nahled', {
        method: 'POST', headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ store_slug: c.slug, cart_token: token || undefined, kandidati: [], kosik: kosik, mena: mena, kurz: rate })
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (o) {
        if (!o) { delete NC[key]; return null; }
        var z = mena === 'CZK' ? Number(o.zaklad) : Number(o.zaklad_mena);
        return { c: isFinite(z) ? Math.round(z * 100) : 0, na: (o.zaklad_na_kod || []).map(String) };
      }).catch(function () { delete NC[key]; return null; });
      NC[key] = p; return p;
    }
    function firstVar(x) { return selVar(x) || sz(x.it.vs)[0] || null; }
    function estimate() {
      clearTimeout(estT);
      var seq = ++estSeq;
      estT = setTimeout(function () {
        var act = active(), others = act.filter(function (x) { return x !== st.main; });
        if (!others.length) { alloc = {}; saveC = 0; hintTxt = ''; if (sumEl) { paintSum(); } pkDone(); return; }
        loadCart().then(function (cart) {
          var pocty = {}, cprice = {};
          ((cart && cart.items) || []).forEach(function (it) {
            if (it.properties && it.properties._pika_darek) return;
            pocty[it.variant_id] = (pocty[it.variant_id] || 0) + it.quantity; cprice[it.variant_id] = it.original_price;
          });
          var tok = cart && cart.token;
          function pack(extra) {
            var pc = {}; Object.keys(pocty).forEach(function (k) { pc[k] = pocty[k]; });
            extra.forEach(function (v) { if (v && !pocty[v.id]) pc[v.id] = 1; });
            return Object.keys(pc).sort().map(function (k) { return { varianta: String(k), mnozstvi: Math.min(10, pc[k]) }; });
          }
          var vars = act.map(firstVar);
          var base = pack([]);
          return Promise.all([base.length ? nahled(base, tok) : Promise.resolve({ c: 0, na: [] }), nahled(pack(vars), tok)]).then(function (r) {
            if (seq !== estSeq) return;
            var save = (r[0] && r[1]) ? Math.max(0, r[1].c - r[0].c) : 0;
            var al = {};
            if (save > 0) {
              var w = {}, sum = 0;
              r[1].na.forEach(function (id) {
                var v = null; vars.forEach(function (x) { if (x && String(x.id) === id) v = x; });
                var pr = v ? v.p : (cprice[id] || 0); if (pr > 0) { w[id] = pr; sum += pr; }
              });
              var left = save, ids = Object.keys(w).filter(function (id) { return vars.some(function (x) { return x && String(x.id) === id; }); });
              ids.forEach(function (id, i) { var part = i === ids.length - 1 ? left : Math.floor(save * w[id] / sum); left -= part; al[id] = part; });
            }
            saveC = save; alloc = al; hintTxt = '';
            if (sumEl) paintSum(); redrawCards();
            if (save > 0) { pkDone(); return; }
            // bez slevy: nabídnout, co by ji přineslo (jen z dat ERP)
            var off = st.slots.filter(function (s) { return !s.on && firstVar(s); });
            return Promise.all(off.map(function (s) { return nahled(pack(vars.concat([firstVar(s)])), tok).then(function (q) { return { s: s, d: (q && r[0]) ? q.c - r[0].c : 0 }; }); })).then(function (res) {
              if (seq !== estSeq) return;
              res.sort(function (a, b) { return b.d - a.d; }); setTimeout(pkDone, 0);
              if (res[0] && res[0].d > 0) {
                var nm = catName(res[0].s.it.k || res[0].s.def.tags[0]).toLowerCase();
                hintTxt = T('add_more_prefix') + nm + T('add_more_suffix') + money(res[0].d);
                if (sumEl) paintSum();
              }
            });
          });
        });
      }, 250);
    }
    function redrawCards() {
      order().forEach(function (o) {
        var idx = o.main ? -1 : o.i, c = box.querySelector('.pika-of__card[data-i="' + idx + '"] .pika-of__price'); if (!c) return;
        var v = selVar(o.x), it = o.x.it, price = v ? v.p : it.p, off = v && alloc[v.id] > 0 && o.x.on ? alloc[v.id] : 0;
        c.innerHTML = off ? '<s class="pika-of__old">' + money(price) + '</s> <b class="pika-of__new">' + money(price - off) + '</b>' : money(price);
      });
    }

    // --- přidání outfitu: kód za celý košík přes společné funkce košíku (jako blok setu) ---
    function buy(btn) {
      var a = active();
      if (a.length < 2) return;
      var miss = a.filter(function (x) { return !selVar(x); })[0];
      if (miss) { var i = miss === st.main ? -1 : st.slots.indexOf(miss); var c = box.querySelector('.pika-of__card[data-i="' + i + '"] [data-act="size"]'); if (c) { c.classList.add('is-need'); c.scrollIntoView({ block: 'center', behavior: 'smooth' }); sizeSheet(miss, c); } return; }
      btn.disabled = true; btn.textContent = T('adding_to_cart');
      var C = window.__PIKA_CART_UPSELL;
      cartItems().then(function (cart) {
        var inCart = {}; ((cart && cart.items) || []).forEach(function (it) { inCart[it.variant_id] = 1; });
        var items = a.filter(function (x) { return !inCart[x.vid]; }).map(function (x) { return { id: x.vid, quantity: 1 }; });
        if (!items.length) { paintSum(); var n0 = sumEl.querySelector('.pika-of__note'); if (n0) { n0.hidden = false; n0.textContent = T('already_in_cart'); } var d0 = document.querySelector('cart-drawer'); if (d0 && typeof d0.show === 'function') { try { d0.show(); } catch (e) {} } return; }
        doAdd(items, C);
      });
    }
    function doAdd(items, C) {
      var zrus = (C && typeof C.zrusSetKody === 'function') ? Promise.resolve().then(function () { return C.zrusSetKody(); }).catch(function () {}) : Promise.resolve();
      var kodP = (C && typeof C.kodZaKosik === 'function')
        ? zrus.then(cartItems).then(function (cart) { return C.kodZaKosik(undefined, { cart: cart || undefined, pridat: items.map(function (i) { return { varianta: String(i.id), mnozstvi: 1 }; }) }); }).catch(function () { return { kod: null }; })
        : Promise.resolve({ kod: null });
      kodP.then(function (odp) {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return odp; });
      }).then(function (odp) {
        var kod = odp && odp.kod;
        var up = (kod && C && typeof C.nasadKod === 'function') ? C.nasadKod(kod) : Promise.resolve();
        return up.then(function () {
          if (C && typeof C.obnovHned === 'function') return Promise.race([Promise.resolve().then(function () { return C.obnovHned(); }).catch(function () {}), new Promise(function (h) { setTimeout(h, 4500); })]);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }).then(function () {
          var d = document.querySelector('cart-drawer'); if (d && typeof d.show === 'function') { try { d.show(); } catch (e) {} }
          var nt = kod ? T('set_discount_applied') : T('added_to_cart');
          loadCart().then(function () { draw(); estimate(); var n = sumEl.querySelector('.pika-of__note'); if (n) { n.hidden = false; n.textContent = nt; } });
        });
      }).catch(function () {
        paintSum();
        var n = sumEl.querySelector('.pika-of__note');
        if (n) { n.hidden = false; n.textContent = T('try_again_error'); }
      });
    }
  }

  /* 2. 10. 2026 — „Hodí se k tomu“ pro produkty, které nejsou oblečení/obuv (outfit se tam neukazuje): 1) Shopify recommendations intent complementary,
     2) stejný typ/typový tag (ERP: tašky, péče o obuv, figurky…) a stejný product_type, 3) doplňky (čepice, ponožky, tašky, péče o obuv); 4–8 karet, jinak se skryje. Žádné slevy. */
  function initPair(el) {
    var cur = el.dataset.handle, pid = el.dataset.pid;
    var ptype = (el.dataset.ptype || '').replace(/"/g, ''), tags = (el.dataset.ptags || '').split('|').filter(Boolean);
    function plain(t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
    var stems = plain(ptype).split(/[^a-z0-9]+/).filter(function (w) { return w.length >= 5; }).map(function (w) { return w.slice(0, 5); });
    lazy(el, function () {
      var ids = [], seenId = {}, out = [], seen = {};
      function addId(id) { id = String(id); if (!seenId[id]) { seenId[id] = 1; ids.push(id); } }
      function viaLook(q, ok) {
        return get(q, 'pika-look').then(function (h) {
          var s = frag(h).querySelector('script[data-pika-cands]'), arr = [];
          try { arr = s ? JSON.parse(s.textContent) : []; } catch (e) {}
          arr.forEach(function (it) { if (it.h !== cur && ok(it)) addId(it.id); });
        });
      }
      var chain = fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=8&intent=complementary', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
        .then(function (d) { ((d && d.products) || []).slice(0, 8).forEach(function (x) { if (x.handle !== cur) addId(x.id); }); });
      function step(fn) { chain = chain.then(function () { return ids.length >= 8 ? null : fn(); }); }
      tags.forEach(function (t) { step(function () { return viaLook('tag:"' + t + '"', function (it) { return (it.tg || '').indexOf(t + '|') > -1; }); }); });
      if (ptype) {
        step(function () { return viaLook('product_type:"' + ptype + '"', function (it) { return it.ty === ptype; }); });
        if (stems.length) step(function () { return viaLook('title:"' + ptype + '"', function (it) { var t = plain(it.t); return stems.some(function (w) { return t.indexOf(w) > -1; }); }); });
      }
      // doplňky: čepice, ponožky, tašky, péče o obuv (jen když předchozí zdroje nedají aspoň 4)
      var pool = [];
      chain = chain.then(function () {
        if (ids.length >= 4) return null;
        return get('tag:Čepice OR tag:Ponožky OR tag:Tašky OR tag:"Péče o obuv"', 'pika-pdp').then(function (h) { cardsOf(h, cur, seen, pool); });
      });
      chain.then(function () {
        return ids.length ? get(ids.slice(0, 8).map(function (x) { return 'id:' + x; }).join(' OR '), 'pika-pdp').then(function (h) { cardsOf(h, cur, seen, out); }) : null;
      }).then(function () {
        pool.forEach(function (c) { if (out.length < 8) out.push(c); });
        out = out.slice(0, 8);
        if (out.length < 4) return hide(el);
        carousel(el, out);
      }).catch(function (e) { window.__pikaErr = String(e && e.stack || e); hide(el); });
    });
  }

  function initRecent(el) {
    var pid = el.dataset.pid, sid = el.dataset.sid, list = [];
    try { list = JSON.parse(localStorage.getItem(LS) || '[]'); if (!Array.isArray(list)) list = []; } catch (e) { list = []; }
    list = list.filter(function (x) { return /^\d+$/.test(String(x)); }).map(String);
    var others = list.filter(function (x) { return x !== pid; }).slice(0, 12);
    try { localStorage.setItem(LS, JSON.stringify([pid].concat(others).slice(0, 13))); } catch (e) {}
    if (!others.length) return;
    el.hidden = false; (el.closest('[data-pika-wrap]') || el).hidden = false;
    lazy(el, function () {
      get(others.map(function (x) { return 'id:' + x; }).join(' OR '), 'pika-recent').then(function (h) {
        var out = [], seen = {};
        cardsOf(h, el.dataset.handle || '', seen, out);
        if (!out.length) return hide(el);
        carousel(el, out.slice(0, 12));
      }).catch(function () { hide(el); });
    });
  }

  function init() {
    document.querySelectorAll('[data-pika-pdp]').forEach(function (el) {
      if (el.__pika) return; el.__pika = 1;
      var k = el.dataset.pikaPdp;
      if (k === 'brand') initBrand(el); else if (k === 'look') initLook(el); else if (k === 'recent') initRecent(el); else if (k === 'pair') initPair(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
